<template>
  <div>
    <main style="margin-top: 92px;">
        <section class="mt-4">
            <div class="container container-width">
                <!-- HEADER DE CATEGORIA -->
                <div class="bg-wearwall rounded-5 p-5">
                    <div class="row align-items-center">
                        <div class="col-xl-3">
                            <h1 class="text-white">Eventos</h1>
                            <div class="d-inline-block p-0 text-capitalize m-0">
                                <nav aria-label="breadcrumb"
                                    style="--bs-breadcrumb-divider: '>'; font-family: 'Lato', sans-serif;">
                                    <ul class="breadcrumb fs-7">
                                        <li class="breadcrumb-item"><a class="text-white fw-bold"
                                            @click="$router.push({ name :'principal',params:{}});" style="cursor: pointer;">
                                            <i class=" text-white far fa-house me-2"></i>Home</a>
                                        </li>
                                        <li class="breadcrumb-item active fw-bold text-white">Eventos</li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                        <div class="col-xl-9 text-end d-none d-xl-block"></div>
                    </div>
                </div>
                <!-- TERMINA HEADER DE CATEGORIA -->



                <!-- CONTENEDOR DE PAGINA -->
                <div class="row flex-row-reverse my-5">
                    <div class="col-12 col-lg-9 col-xl">
                        <div class="d-flex flex-wrap justify-content-between align-items-baseline mb-3">
                            <p class="ff-lato">
                                Se encontraron
                                <span class="text-morado">{{ Filtro.TotalItem }}</span>
                                eventos!
                            </p>
                            <div class="sortby d-flex align-items-center fs-7">
                                <div class="show-elements py-1 px-3 border border-1 rounded-3 d-flex me-2">
                                    <label class="d-flex align-items-center"><i
                                            class="far fa-th-large me-2"></i>Elementos:</label>
                                    <select @change="Lista()" class="form-select border-0 fs-7" aria-label="" v-model="Filtro.Entrada">
                                        <option :value="5">5</option>
                                        <option :value="10">10</option>
                                        <option :value="20">20</option>
                                    </select>
                                </div>
                                <div class="sort-by py-1 px-3 border border-1 rounded-3 d-flex">
                                    <label class="d-flex align-items-center"><i
                                            class="far fa-sort-amount-up me-2"></i>Ordernar:</label>
                                    <select @change="Lista()" class="form-select border-0 fs-7" aria-label="" v-model="Filtro.TipoOrden">
                                        <option value="all">Todos</option>
                                        <!-- <option value="prdnew">Producto Nuevo</option>
                                        <option value="priceasc">Precio de menor a mayor</option>
                                        <option value="pricedesc">Precio de mayor a menor</option> -->
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--  LOADER  -->
                <div v-if="ConfigLoad.ShowLoader" class="row justify-content-center">
                    <div v-for="n in 5" :key="n" class="col-12 col-sm-12 col-md-12 col-lg-10 col-xl-10 mb-4">
                        <div class="card blog_radio_01 hover-up">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                    <figure class="blog_mar">
                                        <svg class="bd-placeholder-img card-img-top" width="100%" height="300" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Placeholder" preserveAspectRatio="xMidYMid slice" focusable="false">
                                            <title>Placeholder</title>
                                            <rect width="100%" height="100%" fill="#868e96"></rect>
                                        </svg>
                                    </figure>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 position-relative">
                                    <article class="blog_midle p-5">
                                        <div class="row placeholder-glow">
                                            <div class="col-12">
                                                <span class="placeholder placeholder-lg col-12"></span>
                                            </div>
                                            
                                        </div>
                                        <br>
                                        
                                        <div class="row">
                                            <div class="col-12 placeholder-glow">
                                                <span class="placeholder placeholder-lg col-12"></span>
                                            </div>
                
                                            <div class="col-12 placeholder-glow">
                                                <span class="placeholder col-12"></span>
                                                <span class="placeholder col-12"></span>
                                                <span class="placeholder col-8"></span>
                                                
                                                
                                            </div>
                                        </div>

                                        <div class="row placeholder-glow">
                                            <div class="col-6 text-start mt-3">
                                                <span class="placeholder col-2"></span>
                                            </div>
                                            <div class="col-6 text-end mt-3">
                                                <span class="placeholder col-2"></span>
                                            </div>
                                        </div>
                                    </article>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--  LISTADO DE EVENTOS  -->
                <div v-if="!ConfigLoad.ShowLoader && ListaArrayRows.length > 0" class="row justify-content-center">
                    <div v-for="(item, index) in ListaArrayRows" :key="index" class="col-12 col-sm-12 col-md-12 col-lg-10 col-xl-10 mb-4">
                        <div class="card blog_radio_01 hover-up">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                    <figure class="blog_mar">
                                      <img :src="rutaImagen+item.IdEvento+'/'+item.LogoEvento" alt="" class="img-fluid blog_radio_02">
                                    </figure>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 position-relative">
                                    <article class="blog_midle p-5">

                                        <div class="row">
                                            <div class="col-12">
                                                <h2 class="mb-4">{{ item.NomEvento }}</h2>
                                            </div>
                                            <div class="col-12">
                                                <p>{{ item.Descripcion }} </p>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-6 text-start mt-3">
                                                <span>{{ $getFormatTextDate(item.FechaEvento,false )}}</span>
                                            </div>
                                            <div class="col-6 text-end mt-3">
                                                <a class="text-morado" @click=" viewEvento(item)" style="cursor: pointer;">Ver más <i class="fas fa-arrow-right"></i></a>
                                            </div>
                                        </div>
                                    </article>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="!ConfigLoad.ShowLoader && ListaArrayRows.length == 0" class="text-center">
                    <h4 class="text-morado">Sin Eventos</h4>
                    <h6>Por el momento no existen eventos programados :(</h6>     
                </div>
                
                <div class="row">
                    <CPagina :Filtro="Filtro" @Pagina="Lista()" ></CPagina>
                </div>


            </div>
        </section>
    </main>

    <ProductosSugeridos v-if="!ConfigLoad.ShowLoader" :IdCategoria="5" :pProducto="1" :pTituloSeccion="'También Podrían Interesarte'"/>
  </div>
</template>

<script>
import ProductosSugeridos from '@/views/catalogos/productos/ProductosSugeridos.vue';
import CPagina from '@/components/CPagina.vue';

export default {
    name: 'ListadoEventos',
    components: {
        CPagina,
        ProductosSugeridos
    },
    data() {
        return {
            ConfigLoad:{
                ShowLoader: false,
                ClassLoad:  true,
            },

            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 5,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                TipoOrden: 'all',

                RangoPrecio:{
                    min: 100,
                    max: 5000,
                    selected:5000
                },
            },

            rutaImagen: '',
            ListaArrayRows: [],
        };
    },

    created() {
        this.bus.$emit('cambiaLogoNegro');
    },

    mounted() {
        this.bus.$emit('cambiaLogoNegro');
        window.scrollTo(0,0);
        sessionStorage.setItem('infoGeneral','');
        
        this.Lista();
    },

    methods: {
        ///shop/eventos

        async Lista() {
            this.ConfigLoad.ShowLoader = true;
            await this.$http.get("eventos",{
                params:{
                    txtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                }
            }).then((res) => {
                this.Filtro.TotalItem    = res.data.data.total;
                this.ListaArrayRows      = res.data.data.data;
                this.rutaImagen          = res.data.rutaFile;
               

            }).finally(()=> {
                this.ConfigLoad.ShowLoader = false;
            });
        },

        viewEvento(item) {
            item.rutaImgs = this.rutaImagen;

            this.$router.push({name: 'viewevento', params:{pEvento:item}});
            sessionStorage.setItem('infoGeneral',JSON.stringify(item));
        }

    },
};
</script>